import { BehaviorStore } from '@proscom/prostore';
import axios from 'axios';
import { isTruthy } from '@proscom/ui-utils';
import { absenceTypesApiUrl } from '../config';

export interface AbsenceTypesStoreState {
  absenceTypes: {
    name: string;
    type: number;
    checkbox: string;
    category: string;
    color?: string;
  }[];
  loaded: boolean;
  loading: boolean;
  error: boolean;
}

export class AbsenceTypesStore extends BehaviorStore<AbsenceTypesStoreState> {
  constructor() {
    super({
      absenceTypes: [],
      loaded: false,
      loading: false,
      error: false
    });

    this.init();
  }

  _setError(error) {
    this.setState({
      loading: false,
      loaded: true,
      error: true
    });
  }

  async loadAbsenceTypes() {
    this.setState({
      loading: true,
      error: false
    });

    try {
      const result = await axios.get(absenceTypesApiUrl);

      if (isTruthy(result.data)) {
        this.setState({
          loading: false,
          loaded: true,
          absenceTypes: result.data
        });
      }
    } catch (error) {
      console.error(error);
      this._setError(error);
    }
  }

  init() {
    this.loadAbsenceTypes();
  }
}
